"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantTypeName = void 0;
exports.GrantTypeName = {
    Token: 'token'
};
//# sourceMappingURL=grantTypeName.js.map